export function balanceStatusStyle(value) {
  const parsedValue = parseFloat(value);

  if (!parsedValue) return "";

  if (parsedValue < 0) {
    return "negative-value";
  } else {
    return "positive-value";
  }
}
